import React, { createRef } from 'react';
import { Flex, xcss, Box } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { useIntl } from '@atlassian/jira-intl';
import { useIntersectionObserver } from '@atlassian/jira-intersection-observer/src/index.tsx';
import messages from './messages.tsx';

type Props = {
	onShowMore: () => void;
	isPaginationLoading?: boolean;
};

const LoadMoreTrigger = ({ onShowMore, isPaginationLoading }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const loadingRef = createRef<HTMLDivElement>();

	const loadMoreRef = useIntersectionObserver({
		margin: 0,
		onIntersection: () => {
			if (!isPaginationLoading) {
				loadingRef?.current?.scrollIntoView();
				onShowMore();
			}
		},
	});

	return (
		<Box role="option" aria-hidden="true" aria-selected={false} ref={loadingRef}>
			<Flex
				xcss={loadingContainerStyles}
				justifyContent="center"
				alignItems="center"
				ref={loadMoreRef}
			>
				<Spinner label={formatMessage(messages.loadingLabel)} />
			</Flex>
		</Box>
	);
};
const loadingContainerStyles = xcss({
	height: '56px',
});

export default LoadMoreTrigger;
